// SkeletonLatestUpdates.tsx
import React from "react";

const SkeletonLatestUpdates: React.FC = () => {
  return (
    <div className="flex-1 bg-white rounded-md border border-gray-200 overflow-hidden flex flex-col animate-pulse">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200">
        <h2 className="font-semibold text-gray-900 py-2.5">
          <div className="h-5 w-24 bg-gray-200 rounded" />
        </h2>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="px-4 py-3 border-b last:border-b-0 border-gray-100 flex flex-col space-y-2"
          >
            <div className="h-4 w-3/4 bg-gray-200 rounded"></div>
            <div className="h-3 w-full bg-gray-200 rounded"></div>
            <div className="h-3 w-1/4 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkeletonLatestUpdates;
